var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 -16 480 480",
    width: "480pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 40h464v400h-464zm0 0",
    fill: "#cfdfe8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 40h464v112h-464zm0 0",
    fill: "#e9686a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7d8d9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 200h64v64h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 200h64v64h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 200h64v64h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 312h64v64h-64zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 312h64v64h-64zm0 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m176 344c0-22.089844-25.070312-40-56-40s-56 17.910156-56 40 25.070312 40 56 40 56-17.910156 56-40zm0 0",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m120 363.3125-21.65625-21.65625 11.3125-11.3125 10.34375 10.34375 58.34375-58.34375 11.3125 11.3125zm0 0",
    fill: "#e9686a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m48 112h64v16h-64zm0 0",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m144 112h16v16h-16zm0 0",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m224 8h32v64h-32zm0 0",
    fill: "#394d5c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m304 8h32v64h-32zm0 0",
    fill: "#394d5c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m64 8h32v64h-32zm0 0",
    fill: "#394d5c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m144 8h32v64h-32zm0 0",
    fill: "#394d5c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m384 8h32v64h-32zm0 0",
    fill: "#394d5c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m424 0h-48v32h-32v-32h-48v32h-32v-32h-48v32h-32v-32h-48v32h-32v-32h-48v32h-56v416h480v-416h-56zm-32 16h16v48h-16zm-80 0h16v48h-16zm-80 0h16v48h-16zm-80 0h16v48h-16zm-80 0h16v48h-16zm392 416h-448v-272h448zm0-384v96h-448v-96h40v32h48v-32h32v32h48v-32h32v32h48v-32h32v32h48v-32h32v32h48v-32zm0 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m168 192h-80v80h80zm-16 64h-48v-48h48zm0 0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m280 192h-80v80h80zm-16 64h-48v-48h48zm0 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m392 192h-80v80h80zm-16 64h-48v-48h48zm0 0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m280 304h-80v80h80zm-16 64h-48v-48h48zm0 0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m392 304h-80v80h80zm-16 64h-48v-48h48zm0 0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m120 392c35.289062 0 64-21.527344 64-48-.292969-11.679688-5.527344-22.6875-14.398438-30.289062l20.054688-20.054688-11.3125-11.3125-22.128906 22.121094c-11.226563-5.660156-23.640625-8.5625-36.214844-8.464844-35.289062 0-64 21.527344-64 48s28.710938 48 64 48zm0-80c8.265625-.027344 16.460938 1.511719 24.152344 4.535156l-24.152344 24.152344-10.34375-10.34375-11.3125 11.3125 21.65625 21.65625 38.289062-38.289062c5.824219 4.625 9.367188 11.546874 9.710938 18.976562 0 17.34375-21.984375 32-48 32s-48-14.65625-48-32 21.984375-32 48-32zm0 0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m48 112h64v16h-64zm0 0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m144 112h16v16h-16zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1b0cd15c7d6266d8132a91df440697ad.svg";
export { ForwardRef as ReactComponent };